import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { CREDITOR_PAYMENT_SEARCH } from "Application/RequestTypes";
import {
  CREDITOR_PAYMENT_DETAIL,
  USER_DETAIL,
  getUrl,
} from "Infrastructure/config/routesConfig";
import SearchTable from "pages/components/Molecules/SearchTable";
import { Link } from "react-router-dom";
import { formatDateTime, formatPrice } from "pages/Utils/Formats";
import { CreditorPayment } from "Domain/Payment/Entity/Payment";
import { getCurrentUserData } from "Application/User/UserService";
import { useState } from "react";
import PaymentStatusChip from "pages/components/Status/PaymentStatusChip";

export default function CreditorPaymentList() {
  const [columns] = useState(getColumns());

  return (
      <SearchTable<CreditorPayment>
        columns={columns}
        additionalFilters={{}}
        endpoint={CREDITOR_PAYMENT_SEARCH}
      />
  );
}

function getColumns() {
  const isCurrentUserInternal = getCurrentUserData().isUserInternal();

  const columns: GridColDef<CreditorPayment>[] = [
    {
      field: "publicId",
      flex: 1,
      renderCell: (params) => (
        <Link to={getUrl(CREDITOR_PAYMENT_DETAIL, { id: params.row.publicId })}>
          {params.row.publicId}
        </Link>
      ),
    },
    {
      field: "paymentAmount",
      flex: 1,
      valueGetter: (value, row) => formatPrice(value),
    },
    {
      field: "date",
      flex: 1,
      type: "string",
      valueGetter: (value, row) => formatDateTime(row.date),
    },
    {
      field: "status",
      flex: 1,
      renderCell: (params) => <PaymentStatusChip status={params.row.status} />,
    },
  ];

  if (isCurrentUserInternal) {
    columns.splice(1, 0, {
      field: "creditor",
      flex: 1,
      renderCell: (params) => (
        <Link
          to={getUrl(USER_DETAIL, { id: params.row.creditorData.publicId })}
        >
          {params.row.creditorData.name}
        </Link>
      ),
    });
  }

  return columns;
}
